<template>
  <div class="pipe-delimitted-list mt-3 d-flex justify-content-end align-items-center flex-wrap">
    <slot v-if="showControls">
      <a
        v-if="showLink"
        class="control"
        :target="commentLinkTarget"
        :href="commentLinkUrl"
      >
        Link
      </a>

      <slot v-if="filterComments">
        <button
          class="control btn btn-link"
          :disabled="isFetching"
          @click="updateAction('resolved', !resolved)"
          @keydown.enter="updateAction('resolved', !resolved)"
        >
          {{ getLabel(resolved, 'Mark as Unresolved', 'Mark as Resolved') }}
        </button>
      </slot>

      <!-- Approve/Unapprove Comment -->
      <button
        v-if="!approved"
        class="control btn btn-link"
        :disabled="isFetching"
        @click="updateAction('approved', true)"
        @keydown.enter="updateAction('approved', true)"
      >
        Approve
      </button>
      <button
        v-else-if="user.isStaff"
        class="control btn btn-link"
        :disabled="isFetching"
        @click="updateAction('approved', undefined)"
        @keydown.enter="updateAction('approved', undefined)"
      >
        Unapprove
      </button>
      <!-- Staff only Controls -->
      <slot v-if="user.isStaff">
        <!-- Deny/Undeny Comment -->
        <button
          v-if="approved || typeof approved === 'undefined' || approved === null"
          class="control btn btn-link"
          :disabled="isFetching"
          @click="updateAction('approved', false)"
          @keydown.enter="updateAction('approved', false)"
        >
          Deny
        </button>
        <button
          v-else
          class="control btn btn-link"
          :disabled="isFetching"
          @click="updateAction('approved', undefined)"
          @keydown.enter="updateAction('approved', undefined)"
        >
          Undeny
        </button>
        <!-- Whitelist -->
        <button
          class="control btn btn-link"
          :disabled="isFetching"
          @click="updateAction('whitelist', !whitelist)"
          @keydown.enter="updateAction('whitelist', !whitelist)"
        >
          {{ getLabel(whitelist, 'Disable approve all posts', 'Approve all posts') }}
        </button>
        <!-- Blacklist -->
        <button
          class="control btn btn-link"
          :disabled="isFetching"
          @click="updateAction('blacklist', !blacklist)"
          @keydown.enter="updateAction('blacklist', !blacklist)"
        >
          {{ getLabel(blacklist, 'Unblock user', 'Block user') }}
        </button>
      </slot>
    </slot>
    <slot v-else-if="showLink">
      <a
        class="control btn btn-link"
        target="_blank"
        :href="commentLinkUrl"
      >
        Link
      </a>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'PDPCommentControls',
  inject: {
    deal: {},
    forDiscussionPage: {
      default: false,
    },
  },
  props: {
    fragmentForLink: {
      type: [String, Number],
      default: null,
    },
    discussionDisplayPath: {
      type: String,
      required: true,
    },
    approved: {
      type: Boolean,
    },
    resolved: {
      type: Boolean,
    },
    pinned: {
      type: Boolean,
    },
    blacklist: {
      type: Boolean,
    },
    whitelist: {
      type: Boolean,
    },
    commentTypeTitle: {
      type: String,
      required: true,
    },
    filterComments: {
      type: Boolean,
    },
    isPinned: {
      type: Boolean,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    forReviews: {
      type: Boolean,
      required: true,
    },
    showLink: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    commentLinkTarget() {
      if (this.forDiscussionPage) {
        return null;
      }
      return '_blank';
    },
    commentLinkUrl() {
      // jw: the fragmentForLink is used to anchor the link to a element on the page. This is not
      //     always present. Discussions linked on the discussion page for example.
      if (this.fragmentForLink) {
        return `${this.discussionDisplayPath}#${this.fragmentForLink}`;
      }
      return this.discussionDisplayPath;
    },
    showControls() {
      return this.user.isAuthenticated && this.user.isModerator;
    },
    isFetching() {
      return this.$store.getters['discussion/isFetching'];
    },
  },
  methods: {
    getLabel(value, labelTrue, labelFalse) {
      return (value) ? labelTrue : labelFalse;
    },
    /**
     * Value types:
     * true       -> "Approved"
     * undefined  -> "Unapproved/Pending Moderation"
     * false      -> "Denied"
     * */
    updateAction(type, value) {
      if (!this.isFetching) {
        this.$emit('update-action', { type, value });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .control,
  .control:visited {
    color: #0275d8;
    cursor: pointer;
    font-family: 'Roboto', sans-serif;
    font-size: 0.8rem;
    padding: 0;
    text-decoration: none;
  }

  .control:hover {
    color: #0056b3;
    text-decoration: none;
  }

  .pipe-delimitted-list .control:not(:first-child)::before {
    margin: 0 0.25rem;
    content: '|';
    color: #ccc;
    cursor: default;
  }
</style>
